import { 
    GET_GROUP,
    REMOVE_GROUPS,
    GET_GROUPS,
    ADD_GROUP,
    UPDATE_GROUP,
    ADD_DATA_COLLECTION_TO_GROUP,
    REMOVE_DATA_COLLECTION_FROM_GROUP,
    ADD_CATEGORIES_TO_GROUP
} from '../constants/action-types';
import { EntityType } from '../constants/EntityType';

// INITIALIZE STATE
const initialState = {
    groups: {},
    group: {},
};

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

// REDUCER
export const GroupReducer = (state = initialState, action) => {
    switch(action.type) {
        case ADD_GROUP: {
            const incomingGroup = action.payload;
            const groups = Object.assign({}, state.groups);

            groups[incomingGroup.id] = incomingGroup;

            return {
                ...state,
                groups
            }
        }
        case GET_GROUP: {
            const groups = Object.assign({}, state.groups);
            const group = action.payload
            groups[group.id] = group

            return {
                ...state,
                groups,
                group,
            }
        }
        case UPDATE_GROUP: {
            const groups = Object.assign({}, state.groups);
            const group = Object.assign({}, state.group);

            const updatedData = action.payload.updatedData;
            const groupId = action.payload.groupId;
            
            Object.keys(updatedData).forEach((data) => {
                group[data] = updatedData[data];
            })

            groups[groupId] = group;
            
            return {
                ...state,
                groups,
                group,
            }
        }
        case GET_GROUPS: {
            const incomingGroups = action.payload;
            const groups = {};

            incomingGroups.forEach((group) => {
                groups[group.id] = group;
            });

            return {
                ...state,
                groups
            }
        }
        case ADD_DATA_COLLECTION_TO_GROUP: {
            var collectionType = null;
            switch (action.payload.collectionType) {
                case EntityType.PRODUCT:
                    collectionType = "products";
                    break;
                case EntityType.CATEGORY:
                    collectionType =  "categories";
                    break;
                case EntityType.MASTERTAG:
                    collectionType =  "masterTags";
                    break;
            }

            const collectionData = action.payload.entityIds;

            const groupIds = action.payload.groupIds;
            const shouldExclude = action.payload.shouldExclude;
            const groups = Object.assign({}, state.groups);
            const group = Object.assign({}, state.group);

            var property = `Included${collectionType.capitalize()}`;

            if (shouldExclude) {
                property = `Excluded${collectionType.capitalize()}`;
            }

            if (!group.hasOwnProperty(property)) {
                group[property] = [];
            }
            
            group[property].push(...collectionData);
            groups[groupIds[0]] = group;

            return {
                ...state,
                groups,
                group,
            }
        }
        case REMOVE_DATA_COLLECTION_FROM_GROUP: {
            var collectionType = null;
            switch (action.payload.collectionType) {
                case EntityType.PRODUCT:
                    collectionType = "products";
                    break;
                case EntityType.CATEGORY:
                    collectionType =  "categories";
                    break;
                case EntityType.MASTERTAG:
                    collectionType =  "masterTags";
                    break;
            }

            const collectionData = action.payload.entityIds;

            const groupIds = action.payload.groupIds;
            const isExcluded = action.payload.isExcluded;
            const groups = Object.assign({}, state.groups);
            const group = Object.assign({}, state.group);

            var property = `Included${collectionType.capitalize()}`;

            if (isExcluded) {
                property = `Excluded${collectionType.capitalize()}`;
            }
            
            collectionData.forEach((collectionId) => {
                const indexToRemove = group[property].findIndex((collectionKey) => collectionKey === collectionId)

                if (indexToRemove > -1) {
                    group[property].splice(indexToRemove, 1);
                }
            })

            groups[groupIds[0]] = group;

            return {
                ...state,
                groups,
                group,
            }
        }
        case ADD_CATEGORIES_TO_GROUP: {
            return {
                ...state,
            }
        }
        case REMOVE_GROUPS: {
            const groupIdsToRemove = action.payload;
            const groups = Object.assign({}, state.groups);

            groupIdsToRemove.forEach((groupId) => {
                delete groups[groupId]
            })

            return {
                ...state,
                groups,
            }
        }
        default:
            return state;
    }
};